import { NotificationRegistry } from '@neos/core'
import NeosDataImportBackgroundExecutionStateChangedEventArgs from '@src/dataObjects/NeosDataImportBackgroundExecutionStateChangedEventArgs'
import NeosDataImportTemplateUpdatedEventArgs from '@src/dataObjects/NeosDataImportTemplateUpdatedEventArgs'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
  /**
   * Gets or sets LogSyncMessage.
   */
  logSyncMessage = this.create<string, void>('LogSyncMessage')

  /**
   * Gets or sets NeosDataImportBackgroundExecutionStateChanged.
   */
  neosDataImportBackgroundExecutionStateChanged = this.create<NeosDataImportBackgroundExecutionStateChangedEventArgs, void>('NeosDataImportBackgroundExecutionStateChanged')

  /**
   * Gets or sets NeosDataImportTemplateUpdated.
   */
  neosDataImportTemplateUpdated = this.create<NeosDataImportTemplateUpdatedEventArgs, void>('NeosDataImportTemplateUpdated')
}